//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientPOST, clientGET } from 'Core/data/RestApi';
import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import moment from 'moment';

//Action types
import {
    VIDFLEET_VIDEO_START_STREAMING,
    VIDFLEET_VIDEO_STOP_STREAMING,
    VIDFLEET_VIDEO_GET_STREAMING_STATUS,
    VIDFLEET_VIDEO_GET_CLIP_BY_ID,
    VIDFLEET_VIDEO_GET_PICTURE_BY_ID,
    VIDFLEET_VIDEO_GET_ONLINE_STATUS,
    VIDFLEET_VIDEO_GET_CLIP_REQUEST_REQUEST,
} from 'Redux/actionTypes';

//actions
import {
    vidFleetVideoStartStreamingResponse,
    vidFleetVideoStopStreamingResponse,
    vidFleetVideoGetStreamingStatusResponse,
    vidFleetVideoGetClipByIdResponse,
    vidFleetVideoGetPictureByIdResponse,
    vidFleetVideoGetCameraOnlineStatusResponse,
    vidFleetVideoGetClipRequestResult
} from 'Redux/actions';

/* FUNTIONS ASYNC */
function* startStreamingRequest({ payload }) {
    const { data: esn } = payload;

    try {

        let QUERY = `
            mutation liveStreaming ($esn: String!, $action: enumLiveStreamingAction!) {
                result: liveStreaming (esn: $esn, action: $action)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                esn: esn,
                action: 'start'
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let resultStart = JSON.parse(data?.result)
            if (resultStart) {
                let res = {};
                res[esn] = resultStart;
                yield put(vidFleetVideoStartStreamingResponse(res));
            } else {
                let res = {};
                res[esn] = { error: true, message: 'vidFleet_errorAccessDenied' };
                yield put(vidFleetVideoStartStreamingResponse(res));
            }
        } else {
            let res = {};
            res[esn] = { error: true, message: 'vidFleet_errorAccessDenied' };
            yield put(vidFleetVideoStartStreamingResponse(res));
        }

    } catch (exc) {
        let res = {};
        res[esn] = { error: true, message: 'vidFleet_errorAccessDenied' };
        yield put(vidFleetVideoStartStreamingResponse(res));
        ExceptionManager(exc, 'modules/devices/components/vidFleetVideo/redux', 'Error while starting VidFleet camera streaming');
    }
}

function* stopStreamingRequest({ payload }) {
    const { data: esn } = payload;

    try {

        let QUERY = `
            mutation liveStreaming ($esn: String!, $action: enumLiveStreamingAction!) {
                result: liveStreaming (esn: $esn, action: $action)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                esn: esn,
                action: 'stop'
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let resultStop = JSON.parse(data?.result)
            if (resultStop) {
                let res = {};
                res[esn] = resultStop;
                yield put(vidFleetVideoStopStreamingResponse(res));
            } else {
                yield put(vidFleetVideoStopStreamingResponse(null));
            }
        } else {
            yield put(vidFleetVideoStopStreamingResponse(null));
        }
    } catch (exc) {
        yield put(vidFleetVideoStopStreamingResponse({ error: exc }));
        // catch throw
        ExceptionManager(exc, 'modules/devices/components/vidFleetVideo/redux', 'Error while starting VidFleet camera streaming');
    }
}

function* getStreamingStatusRequest({ payload }) {
    const { data: esn } = payload;

    try {
        let QUERY = `
            query getStreamingStatus ($esn: String!) {
                result: getStreamingStatus (esn: $esn)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                esn: esn
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let resultStreamingStatus = JSON.parse(data?.result)
            if (resultStreamingStatus) {
                let res = {};
                res[esn] = resultStreamingStatus;
                yield put(vidFleetVideoGetStreamingStatusResponse(res));
            }
        } else {
            yield put(vidFleetVideoGetStreamingStatusResponse(null));
        }
    } catch (exc) {
        yield put(vidFleetVideoGetStreamingStatusResponse({ error: exc }));

        // catch throw
        ExceptionManager(exc, 'modules/devices/components/vidFleetVideo/redux', 'Error while starting VidFleet camera streaming');
    }
}

function* getClipByIdRequest({ payload }) {
    const { data: clipId } = payload;

    let res = {};
    res[clipId] = {};

    try {

        let QUERY = `
            query getClip ($clipId: String!) {
                result: getClip (clipId: $clipId)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                clipId: clipId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let resultClip = JSON.parse(data?.result)
            if (resultClip) {
                res[clipId] = resultClip;
                yield put(vidFleetVideoGetClipByIdResponse(res));
            }
        }

    } catch (exc) {
        res[clipId] = { error: true };
        yield put(vidFleetVideoGetClipByIdResponse(res));
        ExceptionManager(exc, 'modules/devices/components/vidFleetVideo/redux', 'Error while getting clip url video VidFleet camera');
    }
}

function* getPictureByIdRequest({ payload }) {
    const { data: pictureId } = payload;

    let res = {};
    res[pictureId] = {};

    try {

        let QUERY = `
            query getPicture ($pictureId: String!) {
                result: getPicture (pictureId: $pictureId)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                pictureId: pictureId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let resultPicture = JSON.parse(data?.result)
            if (resultPicture) {
                res[pictureId] = resultPicture;
                res[pictureId].expiredTime = moment().add(1, 'h').unix();
                yield put(vidFleetVideoGetPictureByIdResponse(res));
            }
        }
    } catch (exc) {
        res[pictureId] = { error: true };
        yield put(vidFleetVideoGetPictureByIdResponse(res));
        ExceptionManager(exc, 'modules/devices/components/vidFleetVideo/redux', 'Error while getting picture url by id VidFleet camera');
    }
}

function* getCameraOnlineStatusRequest({ payload }) {
    const { data: esn } = payload;
    try {

        let QUERY = `
            query getCameraOnlineStatus ($esn: String!) {
                result: getCameraOnlineStatus (esn: $esn)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                esn: esn
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            try {
                let result = JSON.parse(data?.result)
                if (result) {
                    let signal = "unknown";
                    if (result?.RSRP >= -84) {
                        signal = "excellent";
                    } else if (result?.RSRP < -84 && result?.RSRP >= -102) {
                        signal = "good";
                    } else if (result?.RSRP < -102 && result?.RSRP >= -111) {
                        signal = "fair";
                    } else if (result?.RSRP < -111) {
                        signal = "poor";
                    }

                    let res = {};
                    res[esn] = { ...result, signal };

                    yield put(vidFleetVideoGetCameraOnlineStatusResponse(res));
                }
            } catch (error) {}
        }else {
            yield put(vidFleetVideoGetCameraOnlineStatusResponse(null));
        }
    } catch (exc) {
        // catch throw
        let res = {};
        res[esn] = { error: true, message: 'vidFleet_errorAccessDenied' };
        yield put(vidFleetVideoGetCameraOnlineStatusResponse(res));
        ExceptionManager(exc, 'modules/device/components/vidFleet/redux/saga', 'Error while getting VidFleet camera online status');
    }
}

function* getClipRequest({ payload }) {
    try {
        const QUERY = `
            query getClipRequest ($id: String!) {
                result: getClipRequest (id: $id) {
                    id
                    thumbnailUrl
                    transactionId
                    status
                    unitId
                    label
                    accountId
                    driverId
                    createdBy
                    driver {
                        id
                        name
                    }
                    startDate
                    createdByUser {
                        authId
                        username
                    }
                    endDate
                    errorMsg
                    clipID
                    time
                    tripID
                    latitude
                    longitude
                    url
                    notes
                    gpsTime
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload.id
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(vidFleetVideoGetClipRequestResult(data?.result))
        } else {
            yield put(vidFleetVideoGetClipRequestResult(null))
        }
    } catch (exc) {
        yield put(vidFleetVideoGetClipRequestResult({ error: true }))
    }
}

function* watchMethods() {
    yield takeEvery(VIDFLEET_VIDEO_START_STREAMING, startStreamingRequest);
    yield takeEvery(VIDFLEET_VIDEO_STOP_STREAMING, stopStreamingRequest);
    yield takeEvery(VIDFLEET_VIDEO_GET_STREAMING_STATUS, getStreamingStatusRequest);
    yield takeEvery(VIDFLEET_VIDEO_GET_CLIP_BY_ID, getClipByIdRequest);
    yield takeEvery(VIDFLEET_VIDEO_GET_PICTURE_BY_ID, getPictureByIdRequest);
    yield takeEvery(VIDFLEET_VIDEO_GET_ONLINE_STATUS, getCameraOnlineStatusRequest);
    yield takeEvery(VIDFLEET_VIDEO_GET_CLIP_REQUEST_REQUEST, getClipRequest);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}
